import React, {useEffect, useState} from 'react';
import {StyleSheet, View} from 'react-native';
import {observer} from 'mobx-react-lite';

import {Address} from '../../../models/mfl';
import {useStores} from '../../../stores/use-stores';
import theme from '../../../style/theme';
import TextInputModal from '../../TextInputModal';
import AddressEntry from '../../ui-controls/address/AddressEntry';
import Text from '../../ui-controls/Text';
import Chooser from '../Chooser';
import NominatedPerson from '../NominatedPerson';
import TimeSlots from '../TimeSlots';

//
// Saving of delivery/pickup details is handled by autorun in the cartStore.
//
const PickupDeliverComponent = observer(() => {
  const {cartStore} = useStores();

  const [addressSelected, setAddressSelected] = useState(false);
  const [timeSlotSelected, setTimeSlotSelected] = useState(false);
  const [deliveryInstructionModalVisible, setDeliveryInstructionModalVisible] =
    useState(false);

  // Handle whether we show certain inputs if the prerequisite input has been completed.
  useEffect(() => {
    if (cartStore.isDelivery && cartStore.deliveryAddress) {
      setAddressSelected(true);
    }
  }, [cartStore.deliveryAddress, cartStore.isDelivery]);

  useEffect(() => {
    if (cartStore.isDelivery && cartStore.selectedSlot) {
      setTimeSlotSelected(true);
    }
  }, [cartStore.isDelivery, cartStore.selectedSlot]);

  // Handle the selections/entry of various parts.
  const selectAddress = (address: Address) => {
    cartStore.setDeliveryAddress(address);
  };

  const saveDeliveryInstructions = value => {
    cartStore.setDeliveryInstructions(value);
    setDeliveryInstructionModalVisible(false);
  };

  const deliveryRegulatoryNotice = () => (
    <View style={styles.section}>
      <Text style={styles.deliveryWarning}>
        For first-time delivery orders, the registered customer (18+) must be
        present at the delivery address to receive the order and show a valid
        form of ID to the driver.
      </Text>
    </View>
  );

  return (
    <>
      <Chooser />
      {cartStore.isDelivery ? deliveryRegulatoryNotice() : null}
      {cartStore.isDelivery ? (
        <View
          style={[styles.section, {zIndex: 50}]}
          testID="checkout-screen-delivery-address">
          <Text style={styles.label}>Delivery Address</Text>
          <AddressEntry
            address={cartStore.deliveryAddress || undefined}
            onChange={selectAddress}
            placeholder="Delivery Address"
          />
        </View>
      ) : null}
      {(cartStore.isDelivery && addressSelected) || cartStore.isPickup ? (
        <TimeSlots />
      ) : null}
      {cartStore.isDelivery && timeSlotSelected ? (
        <>
          <NominatedPerson />
          <View
            style={styles.section}
            testID="checkout-screen-delivery-instructions">
            <Text style={styles.label}>Delivery Instructions</Text>
            <TextInputModal
              isVisible={deliveryInstructionModalVisible}
              title="Add note to courier"
              saveAction={saveDeliveryInstructions}
              saveText="UPDATE COURIER NOTE"
              closeAction={() => setDeliveryInstructionModalVisible(false)}
              openAction={() => setDeliveryInstructionModalVisible(true)}
              initialValue={cartStore.deliveryInstructions}
              placeholder="Add note to courier"
            />
          </View>
        </>
      ) : null}
    </>
  );
});

export default PickupDeliverComponent;

const styles = StyleSheet.create({
  section: {
    marginTop: 8,
    zIndex: 40,
  },
  label: {
    color: 'grey',
    fontSize: 12,
    marginBottom: 4,
  },
  deliveryWarning: {
    fontSize: 14,
    color: theme.colour.text.heading.primary,
  },
});
